import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Circle, Popup, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";

export const pin = (label, cls) => L.divIcon({ className: "", html: `<span class="mhh-pin ${cls}">${label}</span>`, iconSize: [0, 0] });

export function Events({ onMove }) {
  useMapEvents({ moveend: (e) => onMove?.(e.target.getBounds()) });
  return null;
}

export function Fly({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    if (center?.[0] && map.getSize().x) map.flyTo(center, zoom || map.getZoom(), { duration: 0.6 });
  }, [center?.[0], center?.[1]]); // eslint-disable-line
  return null;
}

export default function MapView({ items = [], center = [51.5719, -0.777], zoom = 10, activeId, onSelect, onMove, circles = [], className = "h-full", testid = "map-view" }) {
  return (
    <div className={`${className} rounded-2xl overflow-hidden border border-slate-200`} data-testid={testid}>
      <MapContainer center={center} zoom={zoom} scrollWheelZoom className="h-full w-full">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Fly center={center} zoom={zoom} />
        <Events onMove={onMove} />
        {circles.map((c, i) => (
          <Circle key={i} center={[c.lat, c.lng]} radius={(c.miles || 10) * 1609} pathOptions={{ color: "#FF8166", fillColor: "#FF8166", fillOpacity: 0.12, weight: 2 }} />
        ))}
        {items.filter((p) => p.lat).map((p) => (
          <Marker key={p.id} position={[p.lat, p.lng]} icon={pin(p.rating ? `★ ${Number(p.rating).toFixed(1)}` : p.business_name?.slice(0, 12) || "•", activeId === p.id ? "active" : p.sponsored ? "sponsored" : "")}
            eventHandlers={{ click: () => onSelect?.(p.id) }}>
            {p.slug && (
              <Popup>
                <div className="text-sm"><b>{p.business_name}</b><br />{p.town}{p.distance != null && ` · ${p.distance} mi`}<br />
                  <Link to={`/professionals/${p.slug}`} className="text-[#FF8166] font-semibold">View profile →</Link></div>
              </Popup>
            )}
            {p.href && (
              <Popup>
                <div className="text-sm"><b>{p.business_name}</b><br />{p.town}{p.distance != null && ` · ${p.distance} mi`}<br />
                  <Link to={p.href} className="text-[#FF8166] font-semibold">View job →</Link></div>
              </Popup>
            )}
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
